type TranslationFn = (key: string) => string;

const ZOD_TRANSLATION_KEY_PREFIX = "zod.";

export const toTranslationKey = (message: string): string =>
  message.startsWith(ZOD_TRANSLATION_KEY_PREFIX) ? message.slice(ZOD_TRANSLATION_KEY_PREFIX.length) : message;

export async function getTranslatedApiError(
  err: unknown,
  t: TranslationFn,
  fallbackKey: string,
): Promise<string> {
  if (err instanceof Response) {
    const message = (await err.json().catch(() => ({}))).message;
    if (typeof message === "string" && message) return t(toTranslationKey(message));
  }

  return t(fallbackKey);
}
